import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { rotateCuboid } from '../../../state/cuboid-location-state-3d';
import { angleBetween } from '../../../toolbars/measure-toolbar/angle-utils';
import { distanceBetween } from '../../../utils/point-utils';
import {
  AbstractEditPanelDragHandler,
  EditPanelMouseState,
} from './abstract-edit-panel-drag-handler';
import { NdcBoundingBox, isPointInsideBox } from './drag-handler-utils';

export class RotationDragHandler extends AbstractEditPanelDragHandler {
  protected override getTrackEvent() {
    return { method: 'rotate' };
  }

  protected override onDrag(currentMouseState: EditPanelMouseState) {
    let angle = angleBetween(
      currentMouseState.container,
      this.initialMouseState.container,
      'Disambiguate',
    );

    if (this.axis === 1 || this.axis === 2) {
      // Back and Top views are facing the negative direction of their center
      // axis. So we invert the rotation for it to follow the mouse
      angle = -angle;
    }

    const cuboidInitialRotation = this.initialLocation.rotation;
    const newRotation = rotateCuboid(cuboidInitialRotation, this.axis, angle);

    this.store.getFocusedCuboidLocationStore()('rotation').set(newRotation);
  }
}

export function isOverRotation(
  containerPoint: Point2D,
  boundingBox: NdcBoundingBox,
) {
  return (
    isPointInsideBox(containerPoint, getTopLeftHandle(boundingBox)) ||
    isPointInsideBox(containerPoint, getTopRightHandle(boundingBox)) ||
    isPointInsideBox(containerPoint, getBottomRightHandle(boundingBox)) ||
    isPointInsideBox(containerPoint, getBottomLeftHandle(boundingBox))
  );
}

export function getTopLeftHandle({ min, max }: { min: Point2D; max: Point2D }) {
  const handleScale = getHandleScale({ min, max });
  const handleMin: Point2D = [min[0] - handleScale, max[1] - handleScale];
  const handleMax: Point2D = [min[0] + handleScale, max[1] + handleScale];

  return { min: handleMin, max: handleMax };
}

export function getTopRightHandle({
  min,
  max,
}: NdcBoundingBox): NdcBoundingBox {
  const handleScale = getHandleScale({ min, max });
  const handleMin: Point2D = [max[0] - handleScale, max[1] - handleScale];
  const handleMax: Point2D = [max[0] + handleScale, max[1] + handleScale];

  return { min: handleMin, max: handleMax };
}

export function getBottomRightHandle({
  min,
  max,
}: NdcBoundingBox): NdcBoundingBox {
  const handleScale = getHandleScale({ min, max });
  const handleMin: Point2D = [max[0] - handleScale, min[1] - handleScale];
  const handleMax: Point2D = [max[0] + handleScale, min[1] + handleScale];

  return { min: handleMin, max: handleMax };
}

export function getBottomLeftHandle({
  min,
  max,
}: NdcBoundingBox): NdcBoundingBox {
  const handleScale = getHandleScale({ min, max });
  const handleMin: Point2D = [min[0] - handleScale, min[1] - handleScale];
  const handleMax: Point2D = [min[0] + handleScale, min[1] + handleScale];

  return { min: handleMin, max: handleMax };
}

function getHandleScale({ min, max }: NdcBoundingBox) {
  const faceSize = distanceBetween(min, max);
  const cornerAreaProportion = 0.18;
  const handleScale = (faceSize * cornerAreaProportion) / 2;

  return handleScale;
}
